import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import './index.scss'

const SKELETON_WIDTHS = [137, 80]

export default function SkeletonTable({ count = 5 }) {
  return (
    <SkeletonTheme baseColor="var(--color_neutral_400)" highlightColor="var(--color_neutral_200)">
      <div className="LoadingWrapper">
        {Array.from({ length: 10 / 2 }).map((_, index) => (
          <div key={index} className="tableLine">
            <div />
            {[...Array(count)].map((_, i) => (
              <div key={i} className="skeletons">
                {SKELETON_WIDTHS.map((width, j) => (
                  <Skeleton
                    key={j}
                    height={12}
                    borderRadius={20}
                    width={width}
                    containerClassName="SkeletonTable-lines"
                  />
                ))}
              </div>
            ))}
          </div>
        ))}
      </div>
    </SkeletonTheme>
  )
}
